module.exports = __webpack_public_path__ + "static/img/page28.ba59180.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page28.png
// module id = Ago6
// module chunks = 0